<template>
  <v-footer id="footer">
    <v-spacer></v-spacer>
    <div class="text-center">JKTech IT Solutions s.r.o. &copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
</template>

<script>
export default {
  name: 'LayoutFooter'
}
</script>

<style scoped>
#footer{
  display: block;
  margin: auto;
}
</style>
